<template>
    <div class="modal-card usuario-modal">
        <header class="modal-card-head">
            <p class="modal-card-title">{{ $t('MODALUSUARIO.TITULO') }}</p>
            <button type="button" class="delete" aria-label="Fechar" @click="$emit('close')"></button>
        </header>
        <section class="modal-card-body">
            <b-loading :is-full-page="false" :active="isLoading" @update:active="isLoading = $event"></b-loading>

            <div class="usuario-perfil">
                <div class="usuario-foto">
                    <img v-if="foto && !fotoIndisponivel" :src="foto" alt="Foto do usuário" @error="fotoIndisponivel = true">
                    <span v-else class="usuario-foto-vazia"><b-icon icon="account" size="is-large" /></span>
                    <label class="usuario-foto-botao" title="Alterar foto" aria-label="Alterar foto">
                        <input type="file" accept="image/png,image/jpeg" @change="imageFileSelected">
                        <b-icon icon="camera" size="is-small" />
                    </label>
                </div>
                <strong class="usuario-nome" :title="nomeUsuario">{{ nomeUsuario }}</strong>
                <span v-if="descricaoVinculo" class="usuario-vinculo" :title="descricaoVinculoCompleta || descricaoVinculo">{{ descricaoVinculoCompleta }}</span>
            </div>

            <div v-if="empresas.length" class="usuario-secao">
                <p class="usuario-secao-titulo">Unidade</p>
                <b-select :value="unidadeId" expanded aria-label="Unidade" @input="$emit('empresa-selecionada', $event)">
                    <option v-for="empresa in empresas" :key="empresa.id" :value="empresa.id">{{ empresa.nome }}</option>
                </b-select>
            </div>

            <div class="usuario-secao">
                <p class="usuario-secao-titulo">{{ $t('MODALUSUARIO.ALTERARSENHA') }}</p>
                <b-field>
                    <b-input type="password" v-model="novaSenha" placeholder="Nova senha" maxlength="40" :has-counter="false" password-reveal expanded></b-input>
                    <p class="control">
                        <b-button type="is-primary" icon-left="key" :disabled="!novaSenha" @click="alterarSenha()">Alterar</b-button>
                    </p>
                </b-field>
            </div>
        </section>
        <footer class="modal-card-foot usuario-rodape">
            <b-button type="is-danger" outlined icon-left="logout" @click="logout()">{{ $t('SISTEMA.SAIR') }}</b-button>
            <b-button @click="$emit('close')">{{ $t('SISTEMA.FECHAR') }}</b-button>
        </footer>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex'
    import http from '@/http'

    export default {
        props: {
            descricaoVinculo: { type: String, default: '' },
            descricaoVinculoCompleta: { type: String, default: '' },
            unidadeId: { type: Number, default: null },
            empresas: { type: Array, default: () => [] },
        },
        data() {
            return {
                novaSenha: null,
                foto: null,
                fotoIndisponivel: false,
                isLoading: false,
            }
        },
        created() {
            this.foto = `/api/manutencao/funcionarioFoto?id=${this.usuario.funcionarioId}&_cl=${new Date().getTime()}`;
        },
        computed: {
            ...mapState([
                'config',
                'usuario'
            ]),
            nomeUsuario() {
                return String(this.usuario.apelido || this.usuario.nome || '').trim()
            },
        },
        methods: {
            ...mapActions([
                'logout'
            ]),
            registrarErro(err) {
                console.error(err)
                const erros = err && err.body && err.body.errors
                if (erros) {
                    Object.keys(erros).forEach(x => this.$store.commit('ADD_ERRO', x + ": " + erros[x]))
                } else {
                    this.$buefy.toast.open({ duration: 5000, message: 'Não foi possível concluir a operação.', type: 'is-danger', queue: false })
                }
            },
            salvarFuncionarioFoto(imagem) {
                const dadosFotoArray = imagem.split(',');
                dadosFotoArray.shift();
                const newItem = {
                    funcionario: { id: this.usuario.funcionarioId },
                    foto: dadosFotoArray.join()
                }

                this.isLoading = true;
                http.post(`/api/manutencao/salvarFuncionarioFoto`, newItem)
                    .then((res) => {
                        if (res.data != null && res.data.ok != null && res.data.ok == false) {
                            this.$buefy.toast.open({ duration: 5000, message: res.data.mensagem, type: 'is-warning', queue: false })
                            return
                        }
                        this.foto = imagem;
                        this.fotoIndisponivel = false;
                        this.$emit('foto-alterada')
                    })
                    .catch(err => this.registrarErro(err))
                    .finally(() => {
                        this.isLoading = false;
                    });
            },
            imageFileSelected(e) {
                const arquivo = e.target.files[0];
                e.target.value = '';
                if (!arquivo || !arquivo.size || !FileReader) return;
                const fr = new FileReader();
                fr.onload = () => this.salvarFuncionarioFoto(fr.result);
                fr.readAsDataURL(arquivo);
            },
            alteracaoSenha() {
                const model = { novaSenha: this.novaSenha };

                http.post(`/api/manutencao/FuncionarioAlterarSenha`, model)
                    .then((res) => {
                        this.$buefy.toast.open({ duration: 5000, message: res.data.mensagem, type: 'is-success', queue: false });
                    })
                    .catch(err => this.registrarErro(err));

                this.$emit('close')
            },
            alterarSenha() {
                this.$buefy.dialog.confirm({
                    message: this.$t('MODALUSUARIO.ALTERARSENHAMSG'),
                    cancelText: 'Não',
                    confirmText: 'Sim',
                    onConfirm: () => {
                        this.alteracaoSenha();
                    }
                })
            }
        }
    }
</script>

<style scoped>
.usuario-modal {
    width: 420px;
    max-width: calc(100vw - 32px);
}
.usuario-modal .modal-card-body {
    position: relative;
    padding: 24px;
}
.usuario-perfil {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    padding-bottom: 20px;
    border-bottom: 1px solid #edf0f5;
    text-align: center;
}
.usuario-foto {
    position: relative;
    width: 96px;
    height: 96px;
    margin-bottom: 10px;
}
.usuario-foto img,
.usuario-foto-vazia {
    width: 96px;
    height: 96px;
    border-radius: 50%;
}
.usuario-foto img {
    object-fit: cover;
}
.usuario-foto-vazia {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #eef2f8;
    color: #8a96ab;
}
.usuario-foto-botao {
    position: absolute;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border: 2px solid #fff;
    border-radius: 50%;
    background: #007bff;
    color: #fff;
    cursor: pointer;
}
.usuario-foto-botao:hover,
.usuario-foto-botao:focus-within {
    background: #0062cc;
}
.usuario-foto-botao input {
    position: absolute;
    width: 1px;
    height: 1px;
    opacity: 0;
}
.usuario-nome {
    max-width: 100%;
    color: #0b1a3e;
    font-size: 17px;
    line-height: 1.2;
    overflow-wrap: anywhere;
}
.usuario-vinculo {
    color: #53627b;
    font-size: 13px;
}
.usuario-secao {
    padding-top: 18px;
}
.usuario-secao-titulo {
    margin-bottom: 6px;
    color: #53627b;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
}
.usuario-rodape {
    justify-content: space-between;
}
</style>
